/* eslint-disable no-useless-escape */
/* eslint-disable no-eval */
/* eslint-disable camelcase */
/**
 * 获取url参数
 * @param {*} name
 * @returns
 * @example
 * var url = 'http://www.baidu.com?name=123&age=18';
 * var name = getQueryString('name');
 * var age = getQueryString('age');
 * console.log(name, age); // 123 18
 *
 */
import { getCurLanguage, getUrlParams, carryUrlChan } from '@/utils/env';
import { storage, EnumCacheKey } from '@/utils/storage';
import md5 from 'md5';
import did from '@/services/did';
import CryptoJS from 'crypto-js';
import { default as router } from 'next/router';
import { getPayUrl, checkTrust, getTimeStamp } from '@/services/index';

export const getQueryString = (name, search) => {
  if (typeof window === 'undefined') return null;

  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = (search || window.location.search).substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
};

/**
 * 修改地址参数
 * @param {String} arg
 * @param {String} arg_val
 * @returns
 */
export const replaceURLParam = (arg, arg_val) => {
  const url = window.location.href;
  const pattern = `${arg}=([^&]*)`;
  const replaceText = `${arg}=${arg_val}`;

  if (url.match(pattern)) {
    let tmp = `/(${arg}=)([^&]*)/gi`;
    tmp = url.replace(eval(tmp), replaceText);

    return tmp;
  }

  if (url.match('[?]')) {
    return `${url}&${replaceText}`;
  }
  return `${url}?${replaceText}`;
};

/**
 * 静默修改地址参数
 * @param {*} key
 * @param {*} val
 */
export const updateUrlParam = (key, val) => {
  if (typeof window === 'undefined') return;

  try {
    window.history.replaceState(null, null, replaceURLParam(key, val));
  } catch (err) {
    console.log('>>>', err);
  }
};
/**
 * 获取当前地址栏参数
 * @param {*} key
 * @param {*} val
 */
export const getAllUrl = () => {
  if (typeof window === 'undefined') return;
  let str = window.location.origin;
  const match = str.match(/\/\/(.*)/);
  // str = str.slice(8, 100)
  return match[1]?.trim() || '';
};

/**
 * 页面参数转为 JSON
 * @returns
 */
export const formatSeachToJson = () => {
  try {
    let { search } = window.location;

    search = new URLSearchParams(search);

    return Object.fromEntries(search);
  } catch (err) {
    return {};
  }
};

export const getUrl = () => {
  if (typeof window !== 'undefined') {
    return escape(
      window.location.href +
        (getUrlParams('fbclid')
          ? `fb.1.${new Date().getTime()}.${getUrlParams('fbclid')}`
          : storage.getItem('fbclid')
          ? `${storage.getItem('fbclid')}`
          : '')
    ); //escape(window.location.href);
  } else {
    return '当前环境拿不到url';
  }
};
export const getFbclid = () => {
  if (getUrlParams('fbclid') || storage.getItem('fbclid')) {
    return `fb.1.${new Date().getTime()}.${getUrlParams('fbclid') || storage.getItem('fbclid')}`;
  } else {
    return 'no_fbclid';
  }
};
// 获取缓存时间戳标记的 key 名称
const isRequestIngKey = 'isRequestIng';
const cachedTimestampKey = 'cachedTimestamp';
const lastFetchTimeKey = 'lastFetchTime';
const defTimekey = 'defTime';

let fetchServerTimePromise = null;

// 从 storage 获取上次请求的时间戳
let lastFetchTime = storage.getItem(lastFetchTimeKey);
let isRequestIng = storage.getItem(isRequestIngKey) || true;
// 从 storage 获取已缓存的时间戳
let cachedTimestamp = storage.getItem(cachedTimestampKey);
let defTime = storage.getItem(defTimekey); //服务器时间和本地时间差值

// 获取缓存时间戳（确保每分钟请求一次）
const getCachedTime = async () => {
  const currentTime = Math.floor(Date.now() / 1000); // 当前时间戳（秒）
  storage.setItem(lastFetchTimeKey, currentTime); // 更新 storage 中的请求时间戳
  // console.log('_+', currentTime, lastFetchTime, isRequestIng);

  // 如果不存在差值 或者当前时间戳跟现在的时间戳不一致的时候 请求接口
  if (!defTime || currentTime !== lastFetchTime) {
    storage.setItem(isRequestIngKey, true);
    if (isRequestIng && fetchServerTimePromise) {
      return fetchServerTimePromise;
    }

    fetchServerTimePromise = getTimeStamp();

    return fetchServerTimePromise;
  } else {
    //返回本地时间+跟服务器差值时间
    return currentTime + defTime;
  }
};

/**
 *
 * @param {*} i
 * @param {*} type  如果为1 则表示强制替换当前鉴权key
 * @returns
 */
// 同步返回带鉴权 URL
export const getAuthStr = (i, type = undefined) => {
  if (!i) {
    return ''; // 如果没有传入 URL，返回空字符串
  }
  // 如果 URL 已经包含 auth_key，且不强制替换 （type!==1）则不做修改
  if (i.indexOf('auth_key') !== -1 && type !== 1) {
    return i;
  }
  if (i.indexOf('auth_key') !== -1 && type == 1) {
    const urlObj = new URL(i);
    urlObj.searchParams.delete('auth_key'); // 删除旧的auth_key参数
    i = urlObj.toString();
  }
  const timeDiff = storage.getItem(EnumCacheKey['app/timeDiff']) || 0; // 用户本地时间与服务器时间的差值
  const timestamp = Math.floor(Date.now() / 1000) + timeDiff; //当前实时时间 + 差值

  const AUTH = storage.getItem(EnumCacheKey['app/auth']);

  const regex = /https:\/\/(?:[^\/]+\.){2}([^\/]+)\//;
  const match = i.match(regex);
  let url = i;
  try {
    if (!match || !match[1]) {
      return i;
    }
  } catch (error) {}

  const keyword = match[1]; // 提取到的关键字
  const dynamicRegex = new RegExp(`${keyword}(\\S*)`); // 动态生成正则
  const result = i.match(dynamicRegex);

  if (!result || !result[1]) {
    throw new Error('无法匹配 URL 模式');
  }

  const rand = Math.random(); // 随机数，确保每个链接唯一
  storage.setItem('currenttimestamp', timestamp);
  // 构造 auth_key URL 并添加 md5 哈希
  url = `${i}?auth_key=${timestamp}-${rand}-0-${md5(`${result[1]}-${timestamp}-${rand}-0-${AUTH}`)}`;

  return url;
};
export function getRemainingTime() {
  const targetTime = new Date();
  targetTime.setHours(24, 0, 0, 0);

  const currentTime = new Date();
  const timeDiff = targetTime - currentTime;

  const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
  const seconds = Math.floor((timeDiff / 1000) % 60);

  return {
    hours: hours < 10 ? `0${hours}` : hours,
    minutes: minutes < 10 ? `0${minutes}` : minutes,
    seconds: seconds < 10 ? `0${seconds}` : seconds
  };
}
//判断链接里是否携带各个网站的cid参数
//用于dancing页面 看是否展示脱衣
export const hasCid = () => {
  if (
    getUrlParams('fbclid') ||
    getUrlParams('ttclid') ||
    getUrlParams('bbg') ||
    getUrlParams('gclid') ||
    getUrlParams('ScCid') ||
    getUrlParams('click_id') ||
    storage.getItem('hasCid')
  ) {
    storage.setItem('hasCid', true);
    return true;
  } else {
    if (storage.getItem('hasCid')) {
      return true;
    } else {
      return false;
    }
  }
};

/**
 *调取支付
 * @param {sku} sku对象 有acturalAmount的为积分传skuId 没有的为订阅传id
 */
export const goPay = (sku, account) => {
  getPayUrl({ account: account }).then((res) => {
    noReferJump(
      `${res}/?bu=${encryptAES(window.location.origin)}&payType=${sku?.type ? 1 : 0}&skuName=${sku.name}&skuAmount=${
        sku.amount
      }&skuId=${sku.skuId}&token=${
        storage.getItem('authorization') ? storage.getItem('authorization') : ''
      }&did=${did.getValue()}&fbclid=${getAdParams() ? getAdParams() : ''}&chan=${
        getUrlParams('chan') ? getUrlParams('chan') : ''
      }&language=${storage.getItem('language') ? storage.getItem('language') : getCurLanguage()}`
    );
  });
};
/**
 * 获取链接上的广告信息
 * @returns
 */
export const getAdParams = () => {
  // facebook
  if (getUrlParams('fbclid') || storage.getItem('fbclid')) {
    return `fb.1.${new Date().getTime()}.${getUrlParams('fbclid') || storage.getItem('fbclid')}`;
  } else if (getUrlParams('ScCid') || storage.getItem('ScCid')) {
    //Snapchatz
    return `${getUrlParams('ScCid') || storage.getItem('ScCid')}`;
  } else if (getUrlParams('ttclid') || storage.getItem('ttclid')) {
    //Tik Tok
    return `${getUrlParams('ttclid') || storage.getItem('ttclid')}`;
  } else if (getUrlParams('bbg') || storage.getItem('bbg')) {
    //bigo
    return `${getUrlParams('bbg') || storage.getItem('bbg')}`;
  } else if (getUrlParams('click_id') || storage.getItem('click_id')) {
    //快手
    return `${getUrlParams('click_id') || storage.getItem('click_id')}`;
  } else {
    return 'no_fbclid';
  }
};
//如果当前为风险域名 则需要登录后才能继续操作
export const isRisk = () => {
  const webConfig = storage.getItem('app/web/config');
  const uid = storage.getItem('app/user/uid');
  if (webConfig?.isRiskWeb && !uid) {
    return true;
  } else {
    return false;
  }
};
//如果当前为风险域名 结合配置的UID进行下一步操作
export const isRiskUid = () => {
  const webConfig = storage.getItem('app/web/config');
  const uidConfig = webConfig?.uid; //后台配置的uid
  const uid = storage.getItem('app/user/uid'); //当前用户的uid

  if ((webConfig?.isRiskWeb && !uid) || (webConfig?.isRiskWeb && uid > uidConfig)) {
    return true;
  } else {
    return false;
  }
};

//解密
export const decryptAES = (encryptedData) => {
  const secretKey = 'LHGL'; // 密钥

  // 1. URL 解码
  encryptedData = decodeURIComponent(encryptedData);

  const bytes = CryptoJS.AES.decrypt(encryptedData || '1', secretKey); // 解密
  const originalData = bytes.toString(CryptoJS.enc.Utf8); // 转换成原始数据

  return originalData;
};
// 加密函数
export const encryptAES = (data) => {
  const secretKey = 'LHGL'; // 密钥
  // 使用 AES 加密，生成加密结果
  const ciphertext = CryptoJS.AES.encrypt(data, secretKey).toString();
  return ciphertext;
};
//开启风控_未登录用户强制登录  未开启风控_未登录用户不强制登录-20250219
export const hasLogin = () => {
  const webConfig = storage.getItem('app/web/config');
  const uid = storage.getItem('app/user/uid');
  //已开启风控
  if (webConfig?.isRiskWeb) {
    //未登录
    if (!uid) {
      router.push(carryUrlChan('/login'));
      return false;
    }
    //当前用户为风控用户
    if (isRiskUid()) {
      router.push(carryUrlChan('/notice'));
      return true;
    }
    return true;
  } else {
    //未开启风控
    return true;
  }
};
/**
 * 是否为受信任用户
 */
export const isTrustUser = async () => {
  const chanLocal = getUrlParams('chan') || storage.getItem('chan');
  const fbclidLocal = getUrlParams('fbclid') || storage.getItem('fbclid');
  //如果chan里包括sf6cc 则为信任用户（背景：某些广告平台没有fbclid）

  if (chanLocal && chanLocal?.indexOf('sf6cc') !== -1) {
    return true;
  }
  if (chanLocal && fbclidLocal) {
    //如果连接上携带fbclid 且 携带chan的或历史有携带过的则为信任用户
    return true;
  }
  //浏览器指纹判断
  try {
    //接口查询判断
    const res = await checkTrust();
    return res;
  } catch (error) {
    return false;
  }
};
/**
 * 判断高级功能是否展示
 * name:高级功能英文缩写
 * appDate:读取后台配置
 */
export const funcIsShow = (name, appData) => {
  // 等待 isTrust 准备好
  let isTrust = storage.getItem('isTrust');
  // while (isTrust === null || isTrust === undefined) {
  //   await new Promise((resolve) => setTimeout(resolve, 100));
  //   isTrust = await storage.getItem('isTrust');
  // }

  // 信任用户直接返回 true
  if (isTrust) return true;

  if (name === 'eraser' || name === 'eraserVideo') {
    return appData?.webConfig?.unTrustEraser;
  }
  if (name === 'face') {
    return appData?.webConfig?.unTrustFace;
  }
  if (name === 'cloth') {
    return appData?.webConfig?.unTrustCloth;
  }
};
/**
 * 判断是否有过支付行为 前提 开启了风控
 * 调用该方法时 默认当前用户是已经登录状态了（会先调用hasLogin  在那个方法里就已经过滤掉了）
 */
export const checkisPay = (appData) => {
  const webConfig = storage.getItem('app/web/config');
  //未开启风控  当做有支付行为处理 走正常逻辑
  if (!webConfig?.isRiskWeb) {
    return true;
  } else {
    //开启风控，当前用户已登录 判断是否购买过点数为true 或者到期时间大于0 为有过支付行为
    if (appData?.userInfo?.subscribeExpireTime * 1 > 0 || appData?.userInfo?.byPoint) {
      //有过支付行为
      return true;
    } else {
      return false;
    }
  }
};
export const noReferJump = (e) => {
  var link = document.createElement('a');
  link.href = e; // 设置跳转链接
  link.rel = 'noreferrer';
  document.body.appendChild(link);
  link.click();
};
